<section class="card">
    <div class="card-header"> 
      <span class="cat__core__title">
          <strong id="pageTitle">SH-2 Register of Renewed and Duplicate Share Certificates</strong>
      </span>   
      <span style="float: right">
        <!-- <a routerLink="/sh-2"> -->
          <button (click)="addsh2()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button"
          [appHasPermission]="{'Url': '/register/sh2List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh2List'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a>      -->
      </span>
      <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
            <span>
              <i class="fa fa-save"></i>&nbsp;Generate Output </span>
          </button>
        </span>
    </div> 
              <section class="card search-box"> 
                <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
                <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
                        <div class="row">
                          <div class="col-md-3">
                              <label>Date of Approval</label>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <input id="doaIssueofRenewedDuplicateShareCerti" class="form-control" style="padding:6px;z-index: 0;"
                                  placeholder="dd-mm-yyyy" name="doaIssueofRenewedDuplicateShareCerti" ngbDatepicker #a="ngbDatepicker"
                                  (click)="a.toggle();b.close();" [(ngModel)]="doaIssueofRenewedDuplicateShareCerti">
                                <button class="input-group-addon" (click)="a.toggle();b.close();c.close();" type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                              <br>
                            </div>
                          <!-- <div class="col-md-4">
                              <label>Date of issue of Renewed/ Duplicate Share Certificate</label>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                <input id="doiRenewedDuplicateShareCerti" class="form-control" style="padding:6px;z-index: 0;"
                                  placeholder="dd-mm-yyyy" name="doiRenewedDuplicateShareCerti" ngbDatepicker #b="ngbDatepicker"
                                  (click)="b.toggle();a.close();" [(ngModel)]="doiRenewedDuplicateShareCerti">
                                <button class="input-group-addon" (click)="b.toggle();a.close();" type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                            </div> -->
                            <div class="col-md-3">
                              <!-- <label>Date of issue of Renewed/ Duplicate Share Certificate</label> -->
                              <br>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                From:&nbsp;
                                <input id="doiRenewedDuplicateShareCerti" class="form-control" [minDate]="futureFromDate"
                                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doiRenewedDuplicateShareCerti" ngbDatepicker
                                  #b="ngbDatepicker"(click)="b.toggle();a.close();c.close();" [(ngModel)]="doiRenewedDuplicateShareCerti">
                                <button class="input-group-addon"(click)="b.toggle();a.close();c.close();" type="button">
                                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                </button>
                              </div>
                            </div>
  
  
                            <div class="col-md-3">
                
                              <br>
                              <div class="input-group" (click)="$event.stopPropagation()">
                                To:&nbsp;
                                <input id="doiRenewedDuplicateShareCertiTo" class="form-control" [minDate]="futureToDate"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="doiRenewedDuplicateShareCertiTo" ngbDatepicker
                                #c="ngbDatepicker" (click)="c.toggle();a.close();b.close();" [(ngModel)]="doiRenewedDuplicateShareCertiTo">
                              <button class="input-group-addon" (click)="c.toggle();a.close();b.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                              </div>
                            </div>
                          <div class="col-sm-3">
                            <!-- <label>&nbsp;&nbsp;&nbsp;</label> -->
                            <br>
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                                <i class="fa fa-search"></i>&nbsp;Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                          </div>
                        </div>
                     
                    </div>
                  </div>
                </div>
              </section>
              <!-- Date filter End -->
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector" class="table table-hover compact cell-border nowrap stripe"
                          id="directormastersh2Table" style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Name of the person(s)</th>
                              <th>Date of approval</th>
                              <th style="display: none">Date of approval</th>
                              <th>Date of issue <br>of Renewed/ Duplicate <br>Share Certificate</th>
                              <th style="display: none">Date of issue of Renewed/ Duplicate Share Certificate</th>
                              <th>Date of issue <br>of original share<br>certificate</th>
                             
                              <th>Reasons for Renew/<br> Duplicate</th>
                              <th>Original Share<br> Certificate<br> Number</th>
                              <th class="actionclass">Action</th>
                            </tr>
                          </thead>
  
                          <tbody>
                              <tr *ngFor="let director of registerDirectorList;let i=index">
                                 <td tabindex="1"> 
                                  {{director.namePersonRenewedDuplicateCertiisIssued}}
                                 </td>
  
                                  <td>
                                    <span style="display: none">{{director.doaIssueofRenewedDuplicateShareCerti | date : "yMMdd"}}</span>
                                    {{director.doaIssueofRenewedDuplicateShareCerti | date : "dd-MM-y"}}
                                  </td>
                                  <td style="display: none">
                                      {{director.doaIssueofRenewedDuplicateShareCerti | date : "dd-MM-y"}}
                                  </td>
                                  <td>
                                      <span style="display: none">{{director.doiRenewedDuplicateShareCerti | date : "yMMdd"}}</span>
                                      {{director.doiRenewedDuplicateShareCerti | date : "dd-MM-y"}}
                                  </td>
                                  <td style="display: none">
                                        {{director.doiRenewedDuplicateShareCerti | date : "dd-MM-y"}}
                                  </td>
                                     
                                  <td tabindex="1">
                                    {{director.doiOGshareCerti | date: 'dd-MM-yyyy'}}
                                  </td>
                                <td tabindex="1">
                                    {{director.reasonForIssueRenewedDuplicateShareCerti}}
                                </td>   
                                <td tabindex="1"> 
                                    {{director.ogShareCertiNumber}}
                                   </td> 
                                <td>
                                    <div class="input-group">
                                        <button type="button" (click)="editsh2(director._id)" class="btn-sm btn btn-warning"
                                        [appHasPermission]="{'Url': '/register/sh2List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh2List'}">
                                          <span class="fa fa-pencil"></span>
                                        </button>
                                        &nbsp;&nbsp;
                                  <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" 
                                  [appHasPermission]="{'Url': '/register/sh2List/edit?goveva=true&email=', 'method':'put', 'menu': 'sh2List'}">
                                    <span class="icmn-bin" ></span>
                                  </button>
                                    </div>
                                </td>  
                                </tr>
                              </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           
  </section>
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete SH2 details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="removesh2detail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  <app-alert></app-alert>
  